const formatString = (string, ...args) => {
  args.forEach((arg, index) => {
    string = string.replace(`{${index}}`, arg);
  });

  return string;
};

const toBase64 = (string) => {
  return window.btoa(string);
};

const fromBase64 = (base64String) => {
  return window.atob(base64String);
};

const isAlphaNumeric = function (str) {
  var code, i, len;

  for (i = 0, len = str.length; i < len; i++) {
    code = str.charCodeAt(i);
    if (
      !(code > 47 && code < 58) && // numeric (0-9)
      !(code > 64 && code < 91) && // upper alpha (A-Z)
      !(code > 96 && code < 123)
    ) {
      // lower alpha (a-z)
      return false;
    }
  }
  return true;
};

const getHighlightedText = (text, highlight) => {
  try {
    if (highlight && highlight?.length > 0) {
      let searchText = typeof text === "string" ? text : "";

      const parts = searchText.split(new RegExp(`(${highlight})`, "gi"));
      return (
        <>
          {parts.map((part, i) =>
            part.toLowerCase() === highlight.toLowerCase() ? <b key={i}>{part}</b> : part
          )}
        </>
      );
    }
  } catch (e) {
    console.log(e?.toString());
  }

  return text;
};
const capitalize = (s) => {
  return (s && s[0].toUpperCase() + s.slice(1)) || "";
};

const stringUtil = {
  formatString,
  toBase64,
  fromBase64,
  isAlphaNumeric,
  getHighlightedText,
  capitalize
};

export default stringUtil;
